"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.fyrmsSignedMessages = exports.FyrmsSigned = void 0;
const schema_1 = require("../../../schema");
var FyrmsSigned;
(function (FyrmsSigned) {
    FyrmsSigned["FYRMS_SIGNED"] = "FYRMS_SIGNED";
})(FyrmsSigned || (exports.FyrmsSigned = FyrmsSigned = {}));
exports.fyrmsSignedMessages = {
    [FyrmsSigned.FYRMS_SIGNED]: {
        id: "ktx.basicRegistrationData.patientStatementOfConsentFyrms.fyrmsSigned.FYRMS_SIGNED",
        defaultMessage: "A TIMM hozzájáruló nyilatkozatot a beteg aláírásával elfogadta"
    }
};
const fyrmsSigned = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(FyrmsSigned.FYRMS_SIGNED)
]).interpretation({ vocab: "ktx", code: "signed_statement_of_consent_fyrms" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ fyrmsSigned });
